module.exports = __webpack_public_path__ + "static/coach-hire-services-corporate-events-de36cd3d8bb2855fbdead10c06d91f0a.jpg";